import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { Mapped } from "@omni/utils/context/mapped.context";
import { cn } from "@omni/utils/styles";

import { ProductSkeleton } from "@/components/PaintConfigurator/components/products/components/productList/components/product/product.skeleton";
import { useSkeleton } from "@/utils/hooks/useSkeleton.hook";

import { useProductsContext } from "../../context/products.context";
import { NoProductsFound } from "../noProductsFound/noProductsFound";

const Base = ({ children }: RequireChildrenFor<{}>) => {
    const { products, isLoading } = useProductsContext();

    const hasNoProducts = !products || products.length === 0;

    const { showSkeleton, showContent, showLoading } = useSkeleton(isLoading);

    return (
        <div
            className={cn(
                "tw:w-full tw:gap-4 tw:grid tw:grid-cols-1 tw:sm:grid-cols-2 tw:md:grid-cols-3 tw:lg:grid-cols-2 tw:xl:grid-cols-3"
            )}
        >
            {showSkeleton &&
                Array.from({ length: 7 }).map((_, index) => (
                    <ProductSkeleton key={index} />
                ))}
            {showContent &&
                (hasNoProducts ? (
                    <NoProductsFound />
                ) : (
                    <Mapped array={products}>{children}</Mapped>
                ))}
            {showLoading && <div className={cn("tw:h-200")} />}
        </div>
    );
};

export { Base };
